export default defineNuxtRouteMiddleware(to => {
	const redirects: Record<string, string> = {
		'/business/agreement/application': 'https://files.hokify.com/uploads/hokify_Joint_Agreement.pdf'
	};

	if (redirects[to.path]) {
		return navigateTo(redirects[to.path], { redirectCode: 301, external: true });
	}
});
